import { render } from "./contrat-type.vue?vue&type=template&id=627c008c"
import script from "./contrat-type.vue?vue&type=script&lang=js"
export * from "./contrat-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__